import type { ComponentProps, ReactNode } from 'react';

import { cn } from '../lib/cn';
import { Button } from './button';

/** 요청 실패를 그 영역 안에서 알리는 한 줄과 재시도 — E14 §13. 전역 토스트로 밀어내지 않는다. */
export interface InlineErrorProps extends ComponentProps<'p'> {
  onRetry?: () => void;
  /** @default '다시 시도' */
  retryLabel?: ReactNode;
}

export function InlineError({
  className,
  onRetry,
  retryLabel = '다시 시도',
  ...props
}: InlineErrorProps) {
  if (!onRetry) {
    return <p role="alert" className={cn('text-danger text-sm', className)} {...props} />;
  }

  return (
    <div className={cn('gap-snug flex flex-col items-start', className)}>
      <p role="alert" className="text-danger text-sm" {...props} />
      <Button variant="outline" size="sm" onClick={onRetry}>
        {retryLabel}
      </Button>
    </div>
  );
}
